export const CallbackStatusList = [
  { name: "All", value: "all" },
  { name: "1xx informational response", value: "1" },
  { name: "2xx successful", value: "2" },
  { name: "3xx redirection", value: "3" },
  { name: "4xx client error", value: "4" },
  { name: "5xx server error", value: "5" },
]
